import { Field, FIELD_TYPES, Model } from "../../schema";

export default Model("group", {
    verbose_name: "Group",
    verbose_name_plural: "Groups",
    fields: [
        Field("id", {
            label: "ID",
            primary_key: true,
            readonly: true,
            hide: false,
            field_type: FIELD_TYPES.AutoNumber,
        }),

        Field("name", {
            label: "Name",
            primary_key: false,
            readonly: false,
            hide: false,
            required: true,
            field_type: FIELD_TYPES.String,
            default: () => {
                return null;
            },
        }),
        Field("permissions", {
            label: "Permissions",
            primary_key: false,
            readonly: false,
            hide: false,
            required: false,
            field_type: FIELD_TYPES.ManyToMany,
            ref_field_type: "Permission",
            default: () => {
                return [];
            },
        }),
    ],
});
